export default __webpack_public_path__ + "static/image05-a750c7962d5807beae28680fd3e8c432.webp";